export default __webpack_public_path__ + "static/media/typescript-icon.17d5e87e.svg";